// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/InfoBanner/InfoBanner.sass
// module id = 421
// module chunks = 0